import {connect} from 'react-redux';
import ReactModal from 'react-modal';
import React, {Component} from 'react';

import SendMail from '../SendMail';
import ObjectsAPI from '../../../api/Objects';
import ChangeFavorites from '../ChangeFavorites';
import {createOrder} from '../../../actions/Orders';
import {showAuthModal} from '../../../actions/User';
import * as OrderConst from '../../../constants/Order';
import ContactOwner from "../ContactOwner";
import {PROPERTY_PART} from "../../../constants/RoutePaths";

const defaultProps = {
    createOrder: ordersCreateCommand => {
    },
    showAuthModal: isShowAuthModal => {
    }
};

class RequestForPurchase extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isShowPurchaseConfirmModal: false,
            isShowEmailSendModal: false
        }
    }

    handleRequestForPurchaseClick(event) {
        const {accessToken, objectId, userId} = this.props;

        event.preventDefault();

        if (accessToken === null) {
            this.props.showAuthModal(true);
        } else {
            this.setState({
                isShowPurchaseConfirmModal: true
            });
            this.createOrder(OrderConst.SERVICE_TYPE.PURCHASE);
        }
    }

    createOrder(serviceType) {
        const {firstName, lastName, email, code} = this.props;
        const ordersCreateCommand = {
            serviceType: serviceType,
            userName: `${firstName} ${lastName}`,
            contactData: email,
            languageName: code,
            getUserFromContent: true
        };
        this.props.createOrder(ordersCreateCommand);
    }

    handleHidePurchaseConfirmModal(event) {
        event.preventDefault();

        this.setState({
            isShowPurchaseConfirmModal: false
        })
    }

    render() {
        const {i18n} = this.props;

        return (
            <form>
                <div className="button-box">
                    <button
                        type="submit"
                        className="btn"
                        onClick={::this.handleRequestForPurchaseClick}>
                        {i18n['objectPage.requestForPurchase']}
                    </button>
                </div>

                {this.props.currentUser.isAdmin &&
                <div className="button-box">
                    <br />
                    <a href={`/${PROPERTY_PART}/${this.props.objectPage.currentObject.id}/edit`} className="btn-border">
                        <span>Edit</span>
                    </a>
                </div>
                }

                <div className="button-box">
                    <ChangeFavorites />
                    <br />
{/*                    <SendMail />*/}
                    <ContactOwner />
                </div>

                <ReactModal
                    className="custom-react-modal"
                    isOpen={this.state.isShowPurchaseConfirmModal}
                    overlayClassName="custom-react-modal-overlay"
                >
                    {i18n['objectPage.purchaseConfirmMessage']}
                    <br /><br />
                    <button onClick={::this.handleHidePurchaseConfirmModal} className="btn">
                        {i18n['objectPage.callbackClose']}
                    </button>
                </ReactModal>
            </form>
        )
    }
}

RequestForPurchase.defaultProps = defaultProps;

const mapStateToProps = state => ({
    i18n: state.languages.i18n,
    email: state.user.currentUser.email,
    currentUser: state.user.currentUser,
    userId: state.user.currentUser.userId,
    lastName: state.user.currentUser.lastName,
    code: state.languages.currentLanguage.code,
    objectId: state.objectPage.currentObject.id,
    firstName: state.user.currentUser.firstName,
    accessToken: state.user.currentUser.accessToken,
    objectPage: state.objectPage
});

const mapDispatchToProps = {
    createOrder,
    showAuthModal
};

export default connect(mapStateToProps, mapDispatchToProps)(RequestForPurchase);


// WEBPACK FOOTER //
// ./src/components/PropertyPage/Buy/RequestForPurchase.js